import { Injectable } from '@angular/core';
import { AuthGuard, AuthService } from '@auth0/auth0-angular';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { InviteApiController } from '../api-controllers/invite.api-controller';
import { OrganizationManager } from '../managers/organization.manager';
import { LoggingService } from '../../../../modules/src/lib/core/services/logging.service';
import { BillingManager } from '../managers/billing.manager';

@Injectable()
export class HasNoOrganizationGuard implements CanActivate {
  constructor(private readonly authService: AuthService,
              private readonly authGuard: AuthGuard,
              private readonly router: Router,
              private readonly inviteApiController: InviteApiController,
              private readonly organizationManager: OrganizationManager,
              private readonly loggingService: LoggingService,
              private readonly billingManager: BillingManager,
  ) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return new Promise((resolve, reject) => {
      // If you are not logged-in, redirect to login
      this.authGuard.canActivate(route, state).subscribe(async isAuthenticated => {
        if (isAuthenticated === false) {
          this.loggingService.debug('[Guard:\'has-no-organization\'] - User is not authenticated, therefore we determine that user doesn\'t have org and redirect to /login.');
          return resolve(this.router.parseUrl('/login'));
        }

        const organization = await this.organizationManager.getCurrent();
        if (organization !== null) {
          this.loggingService.debug('[Guard:\'has-no-organization\'] - User has an organization, redirecting to /');
          return resolve(this.router.parseUrl('/'));
        }

        return resolve(true);
      });
    });
  }
}
